import styled from "styled-components";
import { GridColDef, GridFilterModel, GridValueFormatterParams, GridValueGetterParams } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { getAllOrders } from "../../../services/orders/get-all";
import { useMutation, useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { GetAllOrdersPayload } from "../../../services/orders/get-all/types";
import { useNavigate } from "react-router-dom";
import { urlOperator } from "../../../utils/url";
import { Button } from "@mui/material";
import { theme } from "../../../helpers/theme";
import { StyledTable } from "../../../components/table/styled-table";
import {
  dateFormating,
  getPurposeFromEnum,
  getStatusFromEnum,
  getTypeFromEnum,
} from "../operator-orders-offering/helpers";

const OperatorOrders = () => {
  const navigate = useNavigate();

  const [ordersPage, setOrdersPage] = useState(0);
  const [ordersFilters, setOrdersFilters] = useState<GridFilterModel>();

  const handleOrdersPageChange = (params:any) => {
    setOrdersPage(params);
  };

  const handleOrdersFilterChange = (params:any, event?:any) => {
    const newFilters = params;
    setOrdersFilters(newFilters);
  };

  useEffect(() => {
    // Load state from session storage
    const savedPage = sessionStorage.getItem('orders-page');
    if (savedPage !== null && savedPage !== undefined) {
      setOrdersPage(parseInt(savedPage));
    }
    const savedFilters = sessionStorage.getItem('orders-filters');
    if (savedFilters !== null && savedFilters !== undefined) {
      try {
        setOrdersFilters(JSON.parse(savedFilters));
      } catch (e) {
        console.error('Error parsing saved filters:', e);
      }
    }
  }, []);

  useEffect(() => {
    // Save state to session storage
    if (ordersPage !== 0 && ordersPage !== undefined) {
      sessionStorage.setItem('orders-page', ordersPage.toString());
    }
    if (ordersFilters !== undefined) {
      sessionStorage.setItem('orders-filters', JSON.stringify(ordersFilters));
    }
  }, [ordersPage, ordersFilters]);

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 250,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
            }}
            onClick={() => {
              return navigate(`/operator/orders/${params.id}`);
            }}
          >
            Szczegóły
          </Button>

          <Button
            variant="contained"
            style={{
              marginLeft: "10px",
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(`/operator/orders/offering/${params.id}`);
            }}
          >
            Ofertowanie
          </Button>
        </>
      ),
    },
    { field: "numer_zamowienia", headerName: "Numer zamówienia", width: 380 },
    { field: "status_zamowienia", headerName: "Status", width: 200 },
    { field: "klient", headerName: "Klient", width: 300 },
    { field: "uslugi_zamowione", headerName: "Cel zamówienia", width: 150 },
    { field: "rodzaj_towaru", headerName: "Rodzaj towaru", width: 150 },
    {
      field: "termin_rozpoczecia",
      type: 'date',
      valueFormatter: (params: GridValueFormatterParams) => {
        return dateFormating(params.value);
      },
      valueGetter: (params: GridValueGetterParams) => {
        return params.value
      },
      headerName: "Termin rozpoczęcia",
      width: 200,
    },
    {
      field: "termin_zakonczenia",
      type: 'date',
      valueFormatter: (params: GridValueFormatterParams) => {
        return dateFormating(params.value);
      },
      valueGetter: (params: GridValueGetterParams) => {
        return params.value
      },
      headerName: "Termin zakończenia",
      width: 200,
    },
  ];

  const [orders, setOrders] = useState<GetAllOrdersPayload[]>([]);

  const body = {
    paginacja: null,
  };

  const GetAllOrders = useQuery(["AllOrders"], () => getAllOrders(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setOrders(data.data.payload.zamowienia);
    },
  });

  const rows = orders.map((r) => ({
    id: r.id_zamowienie,
    numer_zamowienia: r.numer_zamowienia,
    status_zamowienia: getStatusFromEnum(r.status_zamowienia),
    klient: r.klient?.nazwa,
    uslugi_zamowione: getPurposeFromEnum(r.uslugi_zamowione?.cel_zamowienia),
    rodzaj_towaru: getTypeFromEnum(r.rodzaj_towaru),
    termin_rozpoczecia: (r.termin_rozpoczecia),
    termin_zakonczenia: (r.termin_zakonczenia),
  }));

  if (GetAllOrders.isLoading || GetAllOrders.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <OrdersContainer>
      <StyledTable
        getRowId={(row:any) => row?.id}
        rows={rows}
        columns={columns}
        page={ordersPage}
        filterModel={ordersFilters}
        onPageChange={handleOrdersPageChange}
        onFilterModelChange={handleOrdersFilterChange}
        // PageSize={5}
        // rowsPerPageOptions={[5]}
        // autoHeight
        autoPageSize
      //onRowClick={() => navigate(urlOperator.ordersDetails)}
      />
    </OrdersContainer>
  );
};

export default OperatorOrders;

const OrdersContainer = styled.div`
  height: 80vh;
  width: 100% - 300px;
  display: flex;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
